/**
 * @namespace EnumItem
 * @type {EnumItem}
 */
export default class EnumItem {
    /**
     * 
     * @param {String | Number} id = Id do item enum
     */
    constructor(id, key) {
        this.id = id
        this.key = key
    }

    /**
     * Retorna Id do item
     * @returns {String | Number} Id
     */
    getId() {
        return this.id
    }

    /**
     * Retorna Key do item
     * @returns {String} Key
     */
    getKey() {
        return this.key
    }

    /**
     * Dada uma chave, retorna o valor atribuido a esta chave no enum
     * @param {String} attrName - Chave do objeto a ser retornado
     * @returns {Any} valor
     */
    get(attrName) {
        return this[attrName]
    }

    /**
     * Dado um enum, retorna se ele é o mesmo que este enum
     * @param {EnumItem} enumItem - Enum a ser comparado
     * @returns {boolean} equals
     */
    equals(enumItem) {
        if (!enumItem) return false;
        if (!(enumItem instanceof EnumItem)) return false;
        return this.id == enumItem.getId();
    }
}